import GA from "./services/middlewares/googleAnalytics";
import Alert from "./services/middlewares/alert";
import Client from "./services/Client";
import { BASE_URL } from "./config";

// List of all the middlewares to apply
const middlewares = [GA, Alert];

const createMiddlewareInstance = () => middlewares.map((middleware) => new middleware());
const defaultConfig = { credentials: "same-origin" };

const appFetch = new Client(createMiddlewareInstance, {
  baseUrl: BASE_URL,
  defaultConfig,
});
export default appFetch;
